import React from 'react';
import { View, Text,StyleSheet} from '../Primitives'

const styles = StyleSheet.create({

    manifestData:{
        fontSize: 8,
        textAlign: 'left',
        fontFamily:'RobotoRegular',
    },
    manifestDataBold: {
        fontSize: 8,
        textAlign: 'left',
        fontFamily: 'RobotoBold'
    },
    manifestDataBottom:{
        fontSize:8,
        marginBottom:8
    },
    manifestHeader:{
        fontSize:11,
        marginBottom:8,
        color: '#F47820',
        fontFamily: 'RobotoBold',
    },
    manifestColumn: {
        display: 'flex',
        flexDirection:'row',
    }
});

const ManifestRow = ({ manifest,showWeight,hidePhone }) => {
    return <View>
        <View style={styles.manifestColumn} >
            <Text style={styles.manifestDataBold}>{manifest.passengerName}  </Text>
       
            {!hidePhone&& manifest.contactNumber ? <Text style={styles.manifestData}> {manifest.contactNumber} </Text> : null}
            {manifest.emailAddress ?<Text style={styles.manifestData}>{manifest.emailAddress}</Text>:null}
        </View>
        {showWeight ? <View style={styles.manifestColumn} >
            <Text style={styles.manifestData}>Passenger Weight:  {manifest.passengerWeight} </Text>
            <Text style={styles.manifestDataBottom}>Freight Weight:  {manifest.freightWeight + manifest.cargoWeight}</Text>
        </View> : null}
    </View>
}


const Manifest = ({ auth, charter,manifest, showWeight }) => {
    const itineraryHidePhone = auth.role === 'Supplier' ? false : charter.clientDepartment ? charter.clientDepartment.itineraryHidePhone : charter.client.itineraryHidePhone;
    return <View  style={{ marginBottom: 15 }}>
        <Text style={styles.manifestHeader}>Passenger Manifest</Text>
        {manifest.map((x, i) => <ManifestRow key={i} manifest={x} hidePhone={itineraryHidePhone} showWeight={showWeight} />)}
    </View>
}


export default Manifest; 